export type Environment = "sandbox" | "production" | "local";

export const BASE_URLS: Record<Environment, string> = {
  sandbox: "https://adhere-staging-api.smartcomply.com",
  production: "https://adhere-api.smartcomply.com",
  local: "http://127.0.0.1:8000",
};

export interface SDKConfig {
  apiKey: string;
  clientId: string;          // Required UUID — used for session creation
  environment?: Environment;
  timeout?: number;
}
